
import Button from '../button';
import { ButtonPropsEventType, ButtonFillType, ButtonProperty } from '../button/enums';
import { StyleColorSchemeType } from '../../styles/enums';
import TabProps from './mixins/TabProps';
import { TabListEventType, TabProperty } from './enums';

export default {
  name: 'Tab',
  components: {
    Button,
  },
  mixins: [TabProps],
  data() {
    return {
      TabProperty,
      ButtonProperty,
      ButtonPropsEventType,
      ButtonFillType,
    };
  },
  computed: {
    isActive() {
      return this[TabProperty.ActiveIndex] === this[TabProperty.Index];
    },
    colorScheme() {
      return this.isActive ? StyleColorSchemeType.Secondary : StyleColorSchemeType.GrayLight;
    },
  },
  methods: {
    handleTabClick(index) {
      this.$emit(TabListEventType.TabChange, index);
    },
  },

};
